<template>
  <div class="accordion-container">
    <div class="accordion-header" @click="toggle">
      <slot name="header"></slot>
      <ChevronDownIcon class="icon-medium" v-if="!isOpen" />
      <ChevronUpIcon class="icon-medium" v-else />
    </div>
    <transition name="accordion">
      <div v-show="isOpen" class="accordion-body">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import ChevronDownIcon from '@/components/icons/IconChevronDown.vue';
import ChevronUpIcon from '@/components/icons/IconChevronUp.vue';

const props = defineProps({
  defaultOpen: {
    type: Boolean,
    default: false,
  },
});

const isOpen = ref(props.defaultOpen);

const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style scoped lang="scss">
.accordion-container {
  width: 100%;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.accordion-body {
  overflow: hidden;
}

.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.3s ease;
}

.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
}

.accordion-enter-to,
.accordion-leave-from {
  max-height: 62.5rem;
}
</style>
